import {TYPE_MAP} from "../../config";

export default {
  props:{
    data: { type:Array, default: () => ([]) },
    type: { type:Number, default: 3 },
  },
  computed:{
    list: (_this = this) => _this.parseData(_this.$props.data),
    isEmpty: (_this = this) => !_this.list?.length
  },
  methods: {
    /* 解析数据 */
    parseData(list) {
      return list?.
      sort((a, b) => b?.value - a?.value)?.
      map((ele, index, array) => ({
        name: ele?.key,
        lineLength: this.getPercent(ele?.value, array[0]?.value),
        percent: `${this.$retainWan(ele?.percentage * 100,2,false,'--')}%`,
        value: `${TYPE_MAP?.[this.$props.type]?.label}: ${TYPE_MAP?.[this.$props.type]?.formatFn(ele.value)}`
      })).
      splice(0,5)
    },
    /** 获取百分比 */
    getPercent(value,base){
      return `${this.$retainWan(value * 100 * 0.7/ base,false,2,'0')}%`
    }
  },

}
